<template>
    <div class="d-flex align-items-top row">
        <div class="col-md-4 col-sm-8 px-0">
            <select class="form-select form-select-sm" multiple v-model="selected" :size="numOptions">
                <option v-for="option in options" :key="option.value" :value="option.value">
                    {{ option.text }}
                </option>
            </select>
        </div>        
        
        <div class="col-auto">
            <button v-on:click="clearFilter" type="button" class="btn btn-outline-danger btn-sm" :disabled="!hasSelection">
                Limpiar filtro
            </button>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import { EventNames } from '@/plugins/enums/index.js'

export default {
    name: 'FilterRole',
    
    data() {
        return {
            selected: [],
            options: []
        }
    },

    computed: {
        numOptions() {
            return this.options.length
        },
        
        hasSelection() {
            return this.selected.length > 0
        }
    },

    async mounted(){
        let result = await this.allRoles();
        if(result.isError){
            return;
        }

        this.options = result.data.map((r) => {
            return{
                value: r.id, 
                text: r.name
            }
        })
    },

    methods:{
        ...mapActions(["allRoles"]),

        clearFilter() {
            this.selected =[];
        },

        filtrarItem(){
            this.$eventBus.$emit(EventNames.FilterForRole, {
                roles: this.selected
            });
        }
    },

    watch:{
        'selected'(){
            this.filtrarItem();
        }
    }

}
</script>
